import i18n from "@/i18n";
import axios from "@/lib/axios";

class DocumentsService {
  constructor() {
    this.api = axios;
  }

  async getDocuments(filters) {
    const { data } = await this.api.get("/merchant-product-documents", {
      params: filters,
    });

    return data;
  }

  async getDocument(documentId) {
    const { data } = await this.api.get(
      `/merchant-product-documents/${documentId}`,
    );

    return data;
  }

  async createDocument(data, file) {
    const response = await this.api.post(
      `/merchant-product-documents?name=${data.name}&type=${data.type}`,
      file,
    );

    return response;
  }

  async updateDocument(newData, formData) {
    const response = await this.api.put(
      `/merchant-product-documents/${newData.id}?name=${newData.name}`,
      formData,
    );

    return response;
  }

  async deleteDocument(documentId) {
    const response = await this.api.delete(
      `/merchant-product-documents/${documentId}`,
    );

    return response;
  }

  async getDefaultWarrantyDocuments() {
    const { data } = await this.api.get(
      "/default-warranty-document-merchant-info",
    );

    return data;
  }

  cleanInlineStyles = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    const elementsWithStyle = tempDiv.querySelectorAll("[style]");
    elementsWithStyle.forEach((element) => {
      element.removeAttribute("style");
    });

    return tempDiv.innerHTML;
  };

  async createDefaultWarrantyDocument(data) {
    data.warrantyConditions = this.cleanInlineStyles(data.warrantyConditions);
    const response = await this.api.post(
      `/default-warranty-document-merchant-info`,
      data,
    );

    return response;
  }

  async previewDefaultWarrantyDocument() {
    const response = await this.api.get(
      `/default-warranty-document-histories/document-preview`,
    );

    if (response && response.data && response.data.documentCdnUrl) {
      const merchantInfo = encodeURIComponent(
        JSON.stringify(response.data.merchantInfo),
      );

      const previewUrl = `${response.data.documentCdnUrl}&merchantInfo=${merchantInfo}&lang=${i18n.language}`;

      window.open(previewUrl, "_blank");
    }

    return response;
  }

  async updateDefaultWarrantyDocument(data) {
    data.warrantyConditions = this.cleanInlineStyles(data.warrantyConditions);
    const response = await this.api.put(
      `/default-warranty-document-merchant-info/${data.id}`,
      data,
    );
    return response;
  }

  async getMissingDocumentsPaginated(page = 1, size = 10) {
    const { data } = await this.api.get("/merchant-products/incomplete", {
      params: {
        page,
        size,
      },
    });

    return data;
  }

  // Belgeyi ürün id'si ve belge türüyle yükleyen endpoint (FormData)
  async uploadDocumentForProduct({ productId, documentType, file }) {
    const formData = new FormData();
    formData.append("file", file);

    // API endpoint: PUT /merchant-products/{id}/upload-document?name={fileName}&type={documentType}
    const response = await this.api.put(
      `/merchant-products/${productId}/upload-document?name=${encodeURIComponent(
        file.name,
      )}&type=${documentType}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response; // Return full response instead of just data
  }
}

export default new DocumentsService();
